import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import { Tag } from "primereact/tag";
import React from "react";
// import { FaCheck, FaTimes } from "react-icons/fa";

export default function OverstayFeesTable({
  className,
  headers = [
    {
      header_name: "Column 1",
      header_key: "column1",
    },
    {
      header_name: "Column 2",
      header_key: "column2",
    },
  ],
  items = [
    {
      column1: "Column 2",
      column2: "Column 2",
    },
  ],
  isNative = false,
  children,
  linkName,
  linkBody,
  fieldId,
  actionColumn,
  bottomAction,
  multiItemField,
  dt,
  showMorePaymentDetails,
  isForPOD = false,
  dateRange = "",
}) {
  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column
          header="Status"
          colSpan={1}
          field="status"
          sortable
          rowSpan={2}
          alignHeader={"center"}
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        {!isForPOD && (
          <Column
            header="Valid For Refund?"
            colSpan={1}
            field="duplicate"
            sortable
            rowSpan={2}
            alignHeader={"center"}
            headerStyle={{ backgroundColor: "#FECD08" }}
            headerClassName="text-center"
          />
        )}
        <Column
          header="Package Details"
          colSpan={5}
          rowSpan={1}
          alignHeader={"center"}
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        <Column
          header="Payment Details"
          colSpan={
            isForPOD
              ? showMorePaymentDetails
                ? 7
                : 6
              : showMorePaymentDetails
                ? 6
                : 6
          }
          rowSpan={1}
          alignHeader="center"
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
      </Row>
      <Row>
        {/* <Column
					header="Service Type"
					sortable
					field="serviceType"
					alignHeader={"center"}
					headerStyle={{ backgroundColor: "#FECD08" }}
					headerClassName="text-center"
				/> */}
        <Column
          header="Locker Name"
          alignHeader={"center"}
          field="lockerName"
          sortable
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        <Column
          header="Door Size"
          alignHeader={"center"}
          field="doorSize"
          sortable
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        <Column
          header="Sender Mobile"
          alignHeader={"center"}
          sortable
          field="senderMobile"
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        <Column
          header="Recipient Mobile"
          alignHeader={"center"}
          sortable
          field="recipientMobile"
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        <Column
          header="Waybill Number"
          sortable
          field="waybillNumber"
          alignHeader={"center"}
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />

        {isForPOD && (
          <Column
            header="Package Amount"
            alignHeader={"center"}
            field="packagePrice"
            sortable
            headerStyle={{ backgroundColor: "#FECD08" }}
            headerClassName="text-center"
          />
        )}

        {isForPOD && (
          <Column
            header="Transaction Fee"
            field="transactionFee"
            alignHeader={"center"}
            headerStyle={{ backgroundColor: "#FECD08" }}
            headerClassName="text-center"
          />
        )}

        {!isForPOD && (
          <Column
            header="Overstay Fee Amount"
            alignHeader={"center"}
            sortable
            field="excessFee"
            headerStyle={{ backgroundColor: "#FECD08" }}
            headerClassName="text-center"
          />
        )}

        {/* <Column
          header="Total Payment Amount"
          alignHeader={"center"}
          field="totalPaymentAmount"
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        /> */}
        <Column
          header="Payment Currency"
          alignHeader={"center"}
          field="paymentCurrency"
          sortable
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        {/* {showMorePaymentDetails && (
         
        )} */}
        <Column
          header="Payment ID"
          alignHeader={"center"}
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />

        {/* {showMorePaymentDetails && ( */}
        <Column
          header="Payment Date"
          alignHeader={"center"}
          sortable
          field="paymentDate"
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        {/* )} */}
        {/* {showMorePaymentDetails && ( */}
        <Column
          header="Payment Gateway"
          alignHeader={"center"}
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
        />
        {/* )} */}
      </Row>
    </ColumnGroup>
  );

  const rowClassName = (rowData) => {
    if (rowData.transActStatus === 1) {
      return "bg-green-300 border border-black";
    } else if (rowData.transActStatus === 2) {
      return "bg-red-300 border border-black";
    }
    return "border border-black";
  };

  return (
    <DataTable
      paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
      currentPageReportTemplate="Rows per page"
      paginator
      paginatorRight
      rowsPerPageOptions={[10, 20, 50]}
      value={items}
      rows={10}
      headerColumnGroup={headerGroup}
      rowClassName={rowClassName}
      sortMode="multiple"
      // sortField="name"
      // sortOrder={1}
      stripedRows
      header={`Total Packages: ${items.length}`}
      showGridlines={true}
      exportFilename={
        isForPOD
          ? `POD Report (${dateRange})`
          : `Overstay Fees Report (${dateRange})`
      }
      tableStyle={{
        minWidth: "50rem",
        // bor
        borderWidth: 2,
        borderColor: "#E6E6E6",
      }}
      style={{
        borderWidth: "2",
      }}
      removableSort
      ref={dt}
      emptyMessage={"No transactions found"}
      cellSelection={true}
      onCellClick={(e) => {
        // Determine which column was clicked based on e.field value
        const clickedField = e.field;

        // Handle different columns with specific logic
        switch (clickedField) {
          case "waybillNumber":
            // Handle waybill number column click
            if (e.rowData.packageId) {
              window.open(
                `/operator/admin/view-package-history/${e.rowData.packageId}/${e.rowData.userId}`,
                "_blank",
              );
            }
            break;

          case "recipientMobile":
            // Handle recipient mobile column click
            if (e.rowData.userId) {
              window.open(
                `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.userId}`,
                "_blank",
              );
            }
            break;

          case "senderMobile":
            // Handle sender mobile column click

            // if (e.rowData.senderId) {
            //
            if (e.rowData.serviceType === "Storage") {
              window.open(
                `/operator/admin/locker-user-accounts/user-profile-page/${e.rowData.senderId}`,
                "_blank",
              );
            } else {
              window.open(
                `/operator/admin/agents/agentProfile/${e.rowData.partnerAgentId}`,
                "_blank",
              );
            }
            // }
            break;

          default:
            // No specific action for other columns
            break;
        }
      }}
    >
      <Column
        field="status"
        exportHeader="Status"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        body={(rowData) => {
          return (
            <Tag
              value={
                rowData.status === "1"
                  ? "Successful"
                  : rowData.status === "2"
                    ? "Failed"
                    : "Refunded"
              }
              severity={
                rowData.status === "1"
                  ? "success"
                  : rowData.status === "2"
                    ? "danger"
                    : "warning"
              }
              className="text-secondary-purpleGray"
            />
          );
        }}
      />

      {!isForPOD && (
        <Column
          field="duplicate"
          exportHeader="Valid for Refund?"
          className={`text-center max-w-[200px] break-words `}
          sortable
          headerClassName="bg-primary-primaryYellow text-center"
          body={(rowData) => {
            return (
              <Tag
                value={rowData.duplicate ? "Yes" : "No"}
                // severity={rowData.duplicate ? "success" : "warning"}
                // text-secondary-purpleGray
                className={`${
                  rowData.duplicate
                    ? "bg-green-200 text-green-900"
                    : "bg-red-200 text-red-900"
                }`}
              />
            );
          }}
          // body={(rowData) => {
          //   return (
          //     <div className="flex items-center justify-center">
          //       {rowData.duplicate ? (
          //         <i
          //           className="pi pi-check"
          //           style={{ color: "green", fontWeight: "bold" }}
          //         ></i>
          //       ) : (
          //         // <FaCheck style={{ color: "green" }} />
          //         <i
          //           className="pi pi-times"
          //           style={{ color: "red", fontWeight: "bold" }}
          //         ></i>
          //       )}
          //     </div>
          //   );
          // }}
        />
      )}

      {/* <Column
				field="serviceType"
				className={`text-center max-w-[200px] break-words `}
				headerClassName="bg-primary-primaryYellow text-center"
				// sortable
			/> */}
      <Column
        exportHeader="Locker Name"
        field="lockerName"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
      />
      <Column
        field="doorSize"
        exportHeader="Door Size"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        sortable
      />
      <Column
        field="senderMobile"
        exportHeader="Sender/Agent Mobile"
        className={`text-center max-w-[200px] break-words cursor-pointer hover:text-blue-500`}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
      />

      <Column
        field="recipientMobile"
        exportHeader="Recipient Mobile"
        className={`text-center max-w-[200px] break-words cursor-pointer hover:text-blue-500`}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
      />

      <Column
        field="waybillNumber"
        exportHeader="Waybill Number"
        className={`text-center max-w-[200px] break-words cursor-pointer hover:text-blue-500`}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
      />

      {/* no need to display since this report is specific for overstay  */}
      {/* {isForPOD && ( */}
      {isForPOD && (
        <Column
          field="packagePrice"
          exportHeader="Package Price"
          className={`text-center max-w-[200px] break-words `}
          headerClassName="bg-primary-primaryYellow text-center"
          body={(rowData) => <div>₱ {rowData.packagePrice}</div>}
        />
      )}

      {/* )} */}
      {isForPOD && (
        <Column
          field="transactionFee"
          exportHeader="Transaction Fee"
          className="text-center max-w-[200px] break-words"
          headerClassName="bg-primary-primaryYellow text-center"
          body={(rowData) => (
            <div>
              {rowData.transactionFee && rowData.paymentCurrency === "PHP"
                ? `₱ ${rowData.transactionFee?.toFixed(2)}`
                : rowData.transactionFee?.toFixed(2)}
            </div>
          )}
        />
      )}

      {!isForPOD && (
        <Column
          field="excessFee"
          exportHeader="Overstay Fee"
          className="text-center max-w-[200px] break-words"
          headerClassName="bg-primary-primaryYellow text-center"
          body={(rowData) => (
            <div>
              {rowData.excessFee && rowData.paymentCurrency === "PHP"
                ? `₱ ${rowData.excessFee?.toFixed(2)}`
                : rowData.excessFee?.toFixed(2)}
            </div>
          )}
        />
      )}

      {/* <Column
        field="paymentAmount"
        exportHeader="Total Payment Amount"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
        body={(rowData) => (
          <div>
            {rowData.paymentCurrency === "PHP"
              ? `₱ ${rowData.paymentAmount?.toFixed(2)}`
              : rowData.paymentAmount?.toFixed(2)}
          </div>
        )}
      /> */}

      <Column
        field="paymentCurrency"
        exportHeader="Payment Currency"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
      />

      <Column
        field="paymentId"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
      />
      {/* 
      {showMorePaymentDetails && (
       
      )} */}

      {/* {showMorePaymentDetails && ( */}
      <Column
        field="unformattedPaymentDate"
        exportHeader="Payment Date"
        exportField="paymentDate"
        sortable
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        body={(rowData) => {
          return <div>{rowData.paymentDate}</div>;
        }}
      />
      {/* )} */}
      {/* {showMorePaymentDetails && ( */}
      <Column
        field="paymentGateway"
        exportHeader="Payment Gateway"
        className={`text-center max-w-[200px] break-words `}
        headerClassName="bg-primary-primaryYellow text-center"
        // sortable
        body={(rowData) => (
          <div>
            {rowData.paymentCurrency === "PHP"
              ? rowData.paymentGateway
              : `MBOX`}
          </div>
        )}
      />
    </DataTable>
  );
}
